import { useMemo } from 'react';

import useForm from '../utils/useForm';

const useVendorDirectInfoForm = (onSubmit, values) => {
  const fields = useMemo(
    () => [
      {
        title: 'Check Info',
        isTitleHidden: true,
        fields: [
          {
            title: 'Status',
            name: 'vendor_direct_disbursement_data.status',
            type: 'text',
            readOnly: true,
          },
          {
            title: 'Masked card number',
            name: 'vendor_direct_disbursement_data.masked_card_number',
            type: 'text',
            readOnly: true,
          },
          {
            title: 'Settlement date',
            name: 'vendor_direct_disbursement_data.settlement_date',
            type: 'date',
            readOnly: true,
          },
          {
            title: 'Arrives by',
            name: 'vendor_direct_disbursement_data.arrives_by_date',
            type: 'date',
            readOnly: true,
          },
          {
            title: 'VCard account number',
            name: 'vendor_direct_disbursement_data.vcard_account_number',
            type: 'text',
            readOnly: true,
          },
          {
            title: 'Remit email',
            name: 'vendor_direct_disbursement_data.remit_email',
            type: 'text',
            readOnly: true,
          },
          {
            title: 'Payment type',
            name: 'vendor_direct_disbursement_data.payment_type',
            type: 'text',
            readOnly: true,
          },
          {
            title: 'Disbursement status',
            name: 'vendor_direct_disbursement_data.disbursement_status',
            type: 'text',
            readOnly: true,
          },
          {
            title: 'VCard reissue reason',
            name: 'vendor_direct_disbursement_data.vcard_reissue_reason',
            type: 'text',
            readOnly: true,
          },
          {
            title: 'Combined status',
            name: 'vendor_direct_disbursement_data.combined_status',
            type: 'text',
            readOnly: true,
          },
          {
            title: 'Vendor name',
            name: 'vendor_direct_disbursement_data.vendor_name',
            type: 'text',
            readOnly: true,
          },
        ],
      },
    ],
    []
  );

  return useForm({ fields, onSubmit, values });
};

export default useVendorDirectInfoForm;
